import styled from 'styled-components';

export default styled.p`
  font-weight: 500;
`;
